import { getAppLink } from "../utils/getAppLink";
import { getMobileOperatingSystem } from "../utils/utils";

const sidemenuLink = document.querySelector('.sidemenu .download__android');
if (sidemenuLink && (getMobileOperatingSystem() === 'iOS' || getMobileOperatingSystem() === 'MacOS')) {
  sidemenuLink.classList.add('download__ios');
  sidemenuLink.classList.remove('download__android');
  sidemenuLink.innerHTML = sidemenuLink.innerHTML.replace('android', 'ios');
}

const openLink = (element, needLinkForAndroidApp = false) => {
  element.addEventListener('click', () => getAppLink(needLinkForAndroidApp));
}

const onDownloadClick = () => {
  document.querySelectorAll('.download__android').forEach((appLink) => {
    openLink(appLink, true);
  });
  document.querySelectorAll('.download__ios').forEach((appLink) => {
    openLink(appLink);
  });
};


document.addEventListener('DOMContentLoaded', onDownloadClick);
